import React from "react";
import EngineeringIcon from "./EngineeringIcons";

const Services: React.FC = () => {
  const engineeringKeystones = [
    {
      title: "Research & Development",
      description:
        "Pioneering new engineering solutions through cutting-edge research and development. We innovate across all engineering disciplines to create sustainable, efficient, and groundbreaking technologies.",
      image: "engineer.png",
      icon: "🔬",
      category: "Innovation"
    },
    {
      title: "Farm Machinery & Food Processing",
      description:
        "Designing and fabricating advanced agricultural machinery and complete food processing lines. From automated farming equipment to industrial food production systems.",
      image: "palm_oil_mill.png",
      icon: "🚜",
      category: "Agriculture"
    },
    {
      title: "Energy Engineering",
      description:
        "Revolutionary energy solutions including pyrolysis systems, electric-powered outboard motors, and sustainable vehicle technologies for a greener future.",
      image: "maintainance.png",
      icon: "⚡",
      category: "Energy"
    },
    {
      title: "Boats & Yachts Building",
      description:
        "Expert marine engineering and construction of boats, yachts, and watercraft. Combining traditional craftsmanship with modern engineering principles.",
      image: "project1.png",
      icon: "🚢",
      category: "Marine"
    },
    {
      title: "Wood Works Engineering",
      description:
        "Advanced wood processing and manufacturing solutions. From precision cutting to automated woodworking systems and sustainable timber processing.",
      image: "project2.png",
      icon: "🪵",
      category: "Manufacturing"
    },
    {
      title: "Plumbing Engineering",
      description:
        "Comprehensive plumbing systems design and installation. Industrial, commercial, and residential plumbing solutions with sustainable water management.",
      image: "project3.png",
      icon: "🔧",
      category: "Infrastructure"
    },
    {
      title: "Sustainable Building",
      description:
        "Innovative construction solutions including interlocking bricks and eco-friendly building materials. Creating sustainable, durable, and cost-effective structures.",
      image: "foundations.png",
      icon: "🏗️",
      category: "Construction"
    },
    {
      title: "TVET/Skills Training",
      description:
        "Comprehensive technical and vocational education training center. Empowering the next generation of engineers and skilled professionals.",
      image: "quality.jpg",
      icon: "🎓",
      category: "Education"
    },
    {
      title: "Software & Machine Learning",
      description:
        "Cutting-edge software engineering and machine learning hub. Developing intelligent systems, automation solutions, and digital transformation technologies.",
      image: "project4.png",
      icon: "💻",
      category: "Technology"
    },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Our Engineering Keystones</h2>
          <p className="text-gray-600 max-w-4xl mx-auto text-lg">
            Nine specialized engineering pillars working together to industrialize Ekumfiman and create a self-sustainable environment for population-driven development.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {engineeringKeystones.map((keystone, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group engineering-card"
            >
              {/* Service Card */}
              <div className="relative h-64">
                {/* Background Image */}
                <img
                  src={keystone.image}
                  alt={keystone.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />

                {/* Category Badge */}
                <div className="absolute top-4 left-4">
                  <span className="bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    {keystone.category}
                  </span>
                </div>

                {/* Icon Overlay */}
                <div className="absolute top-4 right-4">
                  <div className="text-4xl animate-pulley-bounce">
                    {keystone.icon}
                  </div>
                </div>

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent">
                  {/* Content */}
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-xl font-bold mb-3">{keystone.title}</h3>
                    <p className="text-gray-200 text-sm mb-4 line-clamp-3">{keystone.description}</p>
                    <button className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600 transition-colors flex items-center gap-2 text-sm group">
                      <EngineeringIcon type="gear" size="sm" className="group-hover:animate-gear-spin" />
                      LEARN MORE
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-orange-500 text-white p-8 rounded-lg">
            <h3 className="text-2xl font-bold mb-4">Ready to Industrialize Ekumfiman?</h3>
            <p className="text-lg mb-6">
              Join us in building a sustainable future through engineering excellence. 
              Let's create the infrastructure and innovation that will drive population-driven development.
            </p>
            <button className="bg-white text-orange-500 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
              Start Your Project
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
